import { defineMessage, defineMessages } from "react-intl";
import { defaultCrudMessages } from "../shared/crud/simple-crud";

const _messages = defineMessages({
  entityName: {
    id: "loyaltyCustomer.entityName",
    defaultMessage: "Users",
  },
  name: {
    id: "loyaltyTier.name",
    defaultMessage: "Name",
  },
  ticker: {
    id: "loyaltyTier.ticker",
    defaultMessage: "ticker",
  },
  highlightedNameTop: {
    id: "loyaltyTier.highlightedNameTop",
    defaultMessage: "highlightedNameTop",
  },
  highlightedNameBottom: {
    id: "loyaltyTier.highlightedNameBottom",
    defaultMessage: "highlightedNameBottom",
  },
  description: {
    id: "loyaltyTier.description",
    defaultMessage: "description",
  },
  benefitDescription: {
    id: "loyaltyTier.benefitDescription",
    defaultMessage: "benefitDescription",
  },
  highlightedTextTop: {
    id: "loyaltyTier.highlightedTextTop",
    defaultMessage: "highlightedTextTop",
  },
  highlightedTextBottom: {
    id: "loyaltyTier.highlightedTextBottom",
    defaultMessage: "highlightedTextBottom",
  },
  rgbaColor: {
    id: "loyaltyTier.rgbaColor",
    defaultMessage: "rgbaColor",
  },
  promoCodesList: {
    id: "loyaltyTier.promoCodesList",
    defaultMessage: "promoCodesList",
  },
  amount: {
    id: "loyaltyTier.amount",
    defaultMessage: "amount",
  },
  constant: {
    id: "loyaltyTier.constant",
    defaultMessage: "constant",
  },
  percentage: {
    id: "loyaltyTier.percentage",
    defaultMessage: "percentage",
  },
  discount: {
    id: "loyaltyTier.discount",
    defaultMessage: "discount",
  },
  promotedTier: {
    id: "loyaltyTier.promotedTier",
    defaultMessage: "Promoted Tier",
  },
  save: {
    id: "default.save",
    defaultMessage: "Save",
  },
  highlightedNameTopHelpText: {
    id: "loyaltyTier.highlightedNameTopHelpText",
    defaultMessage: "Help Text",
  },
  highlightedNameBottomHelpText: {
    id: "loyaltyTier.highlightedNameBottomHelpText",
    defaultMessage: "Help Text",
  },
  highlightedTextTopHelpText: {
    id: "loyaltyTier.highlightedTextTopHelpText",
    defaultMessage: "Help Text",
  },
  highlightedTextBottomHelpText: {
    id: "loyaltyTier.highlightedTextBottomHelpText",
    defaultMessage: "Help Text",
  },
  descriptionHelpText: {
    id: "loyaltyTier.descriptionHelpText",
    defaultMessage: "Help Text",
  },
  benefitDescriptionHelpText: {
    id: "loyaltyTier.benefitDescriptionHelpText",
    defaultMessage: "Help Text",
  },
  promoCodesListHelpText: {
    id: "loyaltyTier.promoCodesListHelpText",
    defaultMessage: "Help Text",
  },
  rgbaColorHelpText: {
    id: "loyaltyTier.rgbaColorHelpText",
    defaultMessage: "Help Text",
  },
  discountHelpText: {
    id: "loyaltyTier.discountHelpText",
    defaultMessage: "Help Text",
  },
  tickerHelpText: {
    id: "loyaltyTier.tickerHelpText",
    defaultMessage: "Help Text",
  },
  legalIdentifier: {
    id: "loyaltyCustomer.legalIdentifier",
    defaultMessage: "legalIdentifier",
  },
  login: {
    id: "loyaltyCustomer.login",
    defaultMessage: "login",
  },
  edit: {
    id: "loyaltyCustomer.edit",
    defaultMessage: "edit",
  },
  delete: {
    id: "loyaltyCustomer.delete",
    defaultMessage: "delete",
  },
  active: {
    id: "default.active",
    defaultMessage: "active",
  },
  editLevel: {
    id: "loyaltyCustomer.editLevel",
    defaultMessage: "edit level",
  },
  activeQuestion: {
    id: "default.activeQuestion",
    defaultMessage: "active",
  },
  communicationConsent: {
    id: "loyaltyCustomer.communicationConsent",
    defaultMessage: "emailing",
  },
  locale: {
    id: "loyaltyCustomer.locale",
    defaultMessage: "User language",
  },
  popupWelcomeValidatedEmailTitle: {
    id: "loyaltyCustomer.popupWelcomeValidatedEmailTitle",
    defaultMessage: "User validated",
  },
  popupWelcomeValidatedEmailDescription: {
    id: "loyaltyCustomer.popupWelcomeValidatedEmailDescription",
    defaultMessage: "Send email notification to: {email}?",
  },
  popupWelcomeValidatedEmailErrorTitle: {
    id: "loyaltyCustomer.popupWelcomeValidatedEmailErrorTitle",
    defaultMessage: "User validated error",
  },
  popupWelcomeValidatedEmailErrorDescription: {
    id: "loyaltyCustomer.popupWelcomeValidatedEmailErrorDescription",
    defaultMessage: "Unable to send email notification to: {email}. Please, try again.",
  },
  yes: {
    id: "default.yes",
    defaultMessage: "Yes",
  },
  no: {
    id: "default.no",
    defaultMessage: "No",
  },
  ok: {
    id: "default.ok",
    defaultMessage: "OK",
  },
  view: {
    id: "loyaltyCustomer.view",
    defaultMessage: "View",
  },
  b2bMemberManagedBySalesforce: {
    id: "loyaltyCustomer.b2bMemberManagedBySalesforce",
    defaultMessage:
      "This user belongs to a company or agency: Salesforce creates, edits and deletes it.",
  },
  sendUnmaskedCustomerTooltip: {
    id: "loyaltyCustomer.sendUnmaskedCustomerTooltip",
    defaultMessage: "Send unmasked customer info by email",
  },
  sendCustomersExcelEmailSuccess: {
    id: "loyaltyCustomer.sendCustomersExcelEmailSuccess",
    defaultMessage: "You will receive an email at {email} with the customers Excel file",
  },
  sendCustomersExcelEmailError: {
    id: "loyaltyCustomer.sendCustomersExcelEmailError",
    defaultMessage: "An error occurred trying to send the customers Excel file by email",
  },
  sendUnmaskedCustomerEmailSuccess: {
    id: "loyaltyCustomer.sendUnmaskedCustomerEmailSuccess",
    defaultMessage: "You will receive an email at {email} with the customer info",
  },
  sendUnmaskedCustomerEmailError: {
    id: "loyaltyCustomer.sendUnmaskedCustomerEmailError",
    defaultMessage: "An error occurred trying to send unmasked customer info by email",
  },
  unmaskedErrorTooManyRequests: {
    id: "loyaltyCustomer.unmaskedErrorTooManyRequests",
    defaultMessage:
      "You've reached the maximum unmasked requests by minute. Please, try again later.",
  },
  exportButton: {
    id: "loyaltyCustomer.exportButton",
    defaultMessage: "Download customers Excel",
  },
});

export const customerTableHeaderMessages = defineMessages({
  id: { id: "loyaltyCustomer.id", defaultMessage: "User ID" },
  idHelpText: { id: "loyaltyCustomer.idHelpText", defaultMessage: "Autogenerated user id" },
  name: { id: "loyaltyCustomer.name", defaultMessage: "Name" },
  lastName: { id: "loyaltyCustomer.lastName", defaultMessage: "Lastname" },
  emailAddress: { id: "loyaltyCustomer.emailAddress", defaultMessage: "Email" },
  phoneNumber: { id: "loyaltyCustomer.phoneNumber", defaultMessage: "Phone" },
  birthDate: { id: "loyaltyCustomer.birthDate", defaultMessage: "Born" },
  referrer: { id: "loyaltyCustomer.referrer", defaultMessage: "External user reference" },
  referrerLong: { id: "loyaltyCustomer.referrerLong", defaultMessage: "External user reference" },
  tierType: { id: "loyaltyCustomer.tierType", defaultMessage: "Tier" },
  tagsList: { id: "loyaltyCustomer.tagsList", defaultMessage: "Tags List" },
  country: { id: "loyaltyCustomer.country", defaultMessage: "Country" },
  lCountry: { id: "loyaltyCustomer.country", defaultMessage: "Country" },
  city: { id: "loyaltyCustomer.city", defaultMessage: "City" },
  address: { id: "loyaltyCustomer.address", defaultMessage: "Address" },
  zipCode: { id: "loyaltyCustomer.zipCodeShort", defaultMessage: "ZipCode" },
  "location.country": { id: "loyaltyCustomer.country", defaultMessage: "Country" },
  "location.city": { id: "loyaltyCustomer.city", defaultMessage: "City" },
  "location.address": { id: "loyaltyCustomer.address", defaultMessage: "Address" },
  "location.zipCode": { id: "loyaltyCustomer.zipCode", defaultMessage: "ZipCode" },
  legalIdentifier: { id: "loyaltyCustomer.legalIdentifier", defaultMessage: "legalIdentifier" },
  active: { id: "default.active", defaultMessage: "active" },
  organizationsList: {
    id: "loyaltyCustomer.organizationsList",
    defaultMessage: "organizationsList",
  },
  createdAt: { id: "loyaltyCustomer.createdAt", defaultMessage: "Register Date" },
  communicationConsent: { id: "loyaltyCustomer.communicationConsent", defaultMessage: "Emailing" },
  locale: { id: "loyaltyCustomer.locale", defaultMessage: "Locale" },
  preferencesList: { id: "loyaltyCustomer.preferencesList", defaultMessage: "Preferences" },
});

export const customerMessages = {
  ...defaultCrudMessages,
  ..._messages,
  patternValidationFailed: {
    ".ticker": defineMessage({
      id: "loyaltyTier.tickerPatternFailed",
      defaultMessage: "Must be uppercase. Doesn't allow blank spaces or special characters",
    }),
  },
  tableHeaders: customerTableHeaderMessages,
  deleteDisabledDescription: defineMessage({
    id: "loyaltyTier.deleteDisabledDescription",
    defaultMessage: "This loyalty tier has linked inventory lines, so it can't be deleted.",
  }),
  deletedSucces: defineMessage({
    id: "loyaltyTier.deletedSucces",
    defaultMessage: "Eliminado correctamente",
  }),
  deletedError: defineMessage({
    id: "loyaltyTier.deletedError",
    defaultMessage: "Este usuario no se puede eliminar",
  }),
  deletedSuccesDescription: defineMessage({
    id: "loyaltyTier.deletedSuccesDescription",
    defaultMessage: "El usuario fue eliminado correctamente",
  }),
  deletedErrorDescription: defineMessage({
    id: "loyaltyTier.deletedErrorDescription",
    defaultMessage:
      "Esta usuario tiene reservas asociadas, por lo que no se puede eliminar. Por favor consulte con nuestro departamento de atención al cliente",
  }),
};
